<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="@/assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view></router-view>
  </div>
</template>

<script>
  import { apiConstant } from './request/api'

  export default {
    name: 'App',
    components: {},
    props: {
      active: String
    },
    data() {
      return {}
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.getConstant()
      },
      getConstant() {
        let self = this
        apiConstant().then(res => {
          let data = res.data
          localStorage.setItem('constantDeep', JSON.stringify(data.deep))
          localStorage.setItem('constantMethods', JSON.stringify(data.methods))
          localStorage.setItem('constantSexes', JSON.stringify(data.sexes))
          localStorage.setItem('constantOccupations', JSON.stringify(data.occupations))
          localStorage.setItem('constantActivityCategory', JSON.stringify(data.activityCategory))
          localStorage.setItem('constantActivityStatus', JSON.stringify(data.activityStatus))
        }).catch(err => {
          console.log(err)
        })
      },
    }
  }
</script>

<style>
  
  html,
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transition: none;
  }

  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
    /* transition: all 0.3s ease; */
  }

  #app {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  @media screen and (min-width:769px) {
    .lang-zh {
      font-family: system-ui, -apple-system, Arial, sans-serif;
    }

    .lang-en {
      font-family: system-ui, -apple-system, Arial, sans-serif;
    }

    .lang-es {
      font-family: system-ui, -apple-system, Arial, sans-serif;
    }
  }

  @media screen and (max-width:768px) {
    .lang-zh {
      font-family:  -apple-system, BlinkMacSystemFont, Tahoma, Arial, "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }

    .lang-en {
      font-family: -apple-system,"Helvetica Neue",Helvetica,Arial,sans-serif;
    }

    .lang-es {
      font-family: -apple-system,"Helvetica Neue",Helvetica,Arial,sans-serif;
    }
  }

  .vxe-toolbar{
    height:auto !important;
    margin-bottom: 16px;
  }
  
</style>